import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, map, of, throwError } from 'rxjs';
import { environment } from 'src/environment/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {

  readonly baseUrl: string = `${environment.baseUrl}/api/v1/`;
  private portalId: string = environment.portalId;

  constructor(private http: HttpClient) {}

  postRequest(endpoint: string, data: any): Observable<any> {
    const options = {
      withCredentials: true,
    };
    return this.http.post(this.baseUrl + endpoint, data, options);
  }

  putRequest(endpoint: string, data: any): Observable<any> {
    const options = {
      withCredentials: true,
    };
    return this.http.put(this.baseUrl + endpoint, data, options);
  }

  getRequest(endpoint: string): Observable<any> {
    const options = {
      withCredentials: true,
    };
    return this.http
      .get(this.baseUrl + endpoint, options)
      .pipe(catchError(this.handleError));
  }

  getParamRequest(endpoint: string, params: any): Observable<any> {
    const options = {
      params: params,
      withCredentials: true
    };
    return this.http.get(this.baseUrl + endpoint, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  deleteRequest(endpoint: string): Observable<any> {
    return this.http.delete(this.baseUrl + endpoint);
  }

  deleteRequestOne(endpoint: string, data: any): Observable<any> {
    const options = {
      withCredentials: true,
      body: data,
    };
    return this.http.delete(this.baseUrl + endpoint, options);
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'Unknown error!';

    if (error.error instanceof ErrorEvent) {
      errorMessage = `Client-side error: ${error.error.message}`;
    } else {
      errorMessage = `Server-side error: ${error.status} ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}